"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeRSSI = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const units_1 = require("../units");
/**
 * @category Position
 */
let RelativeRSSI = class RelativeRSSI extends core_1.RelativePosition {
    constructor(referenceObject, rssi) {
        super(referenceObject, rssi);
        this.unit = units_1.PowerUnit.dBm;
    }
    get rssi() {
        return this.referenceValue;
    }
    set rssi(rssi) {
        this.referenceValue = rssi;
    }
};
exports.RelativeRSSI = RelativeRSSI;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [Number])
], RelativeRSSI.prototype, "rssi", null);
exports.RelativeRSSI = RelativeRSSI = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [Object, Number])
], RelativeRSSI);
//# sourceMappingURL=RelativeRSSI.js.map